/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentPlanStatus/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TreatmentPlanStatus({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let treatmentCardTxsTreatmentPlanActionValueData = fromData.useDataValue({ viewPath,
context: 'treatment_card',
path: 'txs.treatment_plan_action',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(treatmentCardTxsTreatmentPlanActionValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}